export const FinancialAccountType = {
  DEPOSITORY: 'depository',
  INVESTMENT: 'investment',
  LOAN: 'loan',
  CREDIT: 'credit'
};
